import { module } from 'modujs';
import { Swiper, Pagination, Lazy } from 'swiper';

Swiper.use([Pagination, Lazy]);

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                next: 'next',
                prev: 'prev'
            }
        }
    }

    init() {
        this.container = this.$('container')[0];
        this.pagination = this.$('pagination')[0];
        this.legend = this.$('legend')[0];

        this.swiper = new Swiper(this.container, {
            grabCursor: true,
            slidesPerView: 1,
            loop: true,
            loopedSlides: 3,
            centeredSlides: true,
            speed: 600,
            shortSwipes: false,
            longSwipesRatio: 0.1,
            longSwipesMs: 50,
            pagination: {
                el: this.pagination,
                type: 'custom',
                renderCustom: (swiper, current, total) => {
                    return current.toString().padStart(2, '0') + ' / ' + total.toString().padStart(2, '0');
                }
            },
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 4
            },
            on: {
                slideChange: (swiper) => {
                    let legend = this.getData('legend', swiper.slides[swiper.activeIndex])
                    this.legend.innerText = legend
                }
            }
        })
    }

    prev() {
        this.swiper.slidePrev();
    }

    next() {
        this.swiper.slideNext();
    }

    destroy() {
        super.destroy()

        this.swiper.destroy()
    }
}
